
import { Type, Link2, Image, BookOpenText, FormInput, Code, Grid, PlaySquare, Timer, HelpCircle, LineChart } from "lucide-react";
import type { Block } from "../types";

export const blockConfig = {
  text: {
    icon: Type,
    label: "Text",
    description: "Add formatted text content"
  },
  image: {
    icon: Image,
    label: "Image",
    description: "Add an image with optional link"
  },
  button: {
    icon: Link2,
    label: "Button",
    description: "Add a button or link with different behaviors"
  },
  "posts": {
    icon: BookOpenText,
    label: "Posts List",
    description: "Add a list of blog posts"
  },
  "form": {
    icon: FormInput,
    label: "Inline Form",
    description: "Add the funnel form directly in the section"
  },
  "embed": {
    icon: Code,
    label: "Embed",
    description: "Add external content via embed code"
  },
  "feature-grid": {
    icon: Grid,
    label: "Feature Grid",
    description: "Add 3-4 column feature highlights"
  },
  "video": {
    icon: PlaySquare,
    label: "Video Block",
    description: "Add YouTube/Vimeo video embed"
  },
  "countdown": {
    icon: Timer,
    label: "Countdown Timer",
    description: "Add countdown for limited time offers"
  },
  "faq": {
    icon: HelpCircle,
    label: "FAQ Accordion",
    description: "Add frequently asked questions"
  },
  "progress": {
    icon: LineChart,
    label: "Progress Bar",
    description: "Add progress indicator for courses"
  }
} as const;

export type BlockType = keyof typeof blockConfig;
